import { render, staticRenderFns } from "./ScanBerkasRMDetails.vue?vue&type=template&id=18d73d63"
import script from "./ScanBerkasRMDetails.vue?vue&type=script&lang=js"
export * from "./ScanBerkasRMDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d73d63')) {
      api.createRecord('18d73d63', component.options)
    } else {
      api.reload('18d73d63', component.options)
    }
    module.hot.accept("./ScanBerkasRMDetails.vue?vue&type=template&id=18d73d63", function () {
      api.rerender('18d73d63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/master_pasien/ScanBerkasRMDetails.vue"
export default component.exports